import * as actionTypes from "~/store/action_types";
import Angie from "~/utils/angie.jsx";
import { fetch } from "~/utils/fetch.jsx";

export const fetchUserWorkweek = (userId) => {
  return {
    types: [
      actionTypes.FETCH_USER_WORKWEEK_LOADING,
      actionTypes.FETCH_USER_WORKWEEK_SUCCESS,
      actionTypes.FETCH_USER_WORKWEEK_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/${userId}/workweek`,
      }),
    payload: { userId },
  };
};

export const editUserWorkweek = (userId, weeklyWorkerCapacities) => {
  return {
    types: [
      actionTypes.EDIT_USER_WORKWEEK_LOADING,
      actionTypes.EDIT_USER_WORKWEEK_SUCCESS,
      actionTypes.EDIT_USER_WORKWEEK_ERROR,
    ],
    callAPI: () =>
      fetch({
        url: `${Angie.api_url}/users/${userId}/workweek`,
        method: "PUT",
        body: { weekly_worker_capacity: weeklyWorkerCapacities },
      }),
    payload: { userId },
  };
};
